<script>
  import { format } from 'svelte-i18n';
  import { Button, Col, Input } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { QRCode } from '@client/components/qr-code';

  import { ImageItem, SearchInput } from '@client/pages/brandkit/components';

  import { companyUrl } from '@client/stores/brand';
  import { userStore as currentUser } from '@client/stores/user';

  export let active = false;
  export let onDragStart = (event, item) => {};

  const smartUrl = `${$currentUser.cname[0]}://${$currentUser.cname[1]}/bizcard/{{ sgsusername }}/`;

  let qrCodes = [
    { name: $format('label.COMPANY_URL'), url: $companyUrl },
    { name: $format('label.BUSINESS_CARD'), url: smartUrl }
    // TODO vcard
  ];

  let nameInput;
  let newName = '';
  let newUrl = '';
  let searchInput;
  let searchQuery = '';
  let showAddForm = false;

  const addQRCode = () => {
    if (newName && newUrl) {
      qrCodes = [...qrCodes, { name: newName, url: newUrl }];
      newName = '';
      newUrl = '';
      showAddForm = false;
    }
  };

  const onCancel = () => {
    newName = '';
    newUrl = '';
    showAddForm = false;
  };

  $: filteredCodes = qrCodes.filter(
    (qr) =>
      qr.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      qr.url.toLowerCase().includes(searchQuery.toLowerCase())
  );

  $: if (active && searchInput) searchInput.focus();

  $: if (showAddForm && nameInput) nameInput.focus();
</script>

{#if qrCodes?.length}
  <header class="sticky-top bg-white p-3 pb-2">
    <SearchInput bind:value={searchQuery} bind:inner={searchInput} />
  </header>
{/if}

<div class="p-3 pt-1">
  {#each filteredCodes as qr}
    <ImageItem
      draggable="true"
      name={qr.name}
      description={qr.url}
      on:dragstart={(e) => onDragStart(e, `{{ "${qr.url}" | qr_code }}`)}
    >
      <QRCode class="img-fluid" alt={qr.name} data={qr.url} />
    </ImageItem>
  {/each}
</div>

{#if showAddForm}
  <div class="row px-3 py-1" role="listitem">
    <Col xs={4} class="text-center">
      <div class="preview">
        <QRCode class="img-fluid" alt={newName} data={newUrl || '?'} />
      </div>
    </Col>
    <Col xs={8}>
      <Input
        type="text"
        bsSize="sm"
        placeholder={$format('label.NAME')}
        bind:value={newName}
        bind:inner={nameInput}
        class="mb-1"
      />
      <Input type="text" bsSize="sm" placeholder={$format('label.URL')} bind:value={newUrl} class="mb-1" />
      <footer class="d-flex">
        <Button size="sm" color="primary" class="me-1" on:click={addQRCode} disabled={!newName || !newUrl}>
          {$format('label.ADD')}
        </Button>
        <Button size="sm" on:click={onCancel}>{$format('label.CANCEL')}</Button>
      </footer>
    </Col>
  </div>
{:else}
  <div class="px-3 py-1">
    <Button size="sm" color="link" block on:click={() => (showAddForm = true)}>
      <Icon name="plus" />
      {$format('label.ADD_QR_CODE')}
    </Button>
  </div>
{/if}
